/**
 * Copyright (c) 2026, CheckPlus Limited
 */

import React, { Component } from "react";
import PropTypes from "prop-types";
import "./LoginPassword.css";
import { Link } from "react-router-dom";
//import { validPw } from '../../assets/validators/donorInfo.js';
import { validLoginDonor } from "../../assets/validators/donorInfo.js";
import { Helmet } from "react-helmet";
import { resolveThemeColors } from "../../assets/helper";

class LoginPassword extends Component {
  constructor(props) {
    super(props);
    if (this.props.location.state === undefined) {
      if (this.props.history.length <= 1) {
        this.props.history.push("/");
        return;
      } else {
        this.props.history.push("/LoginEmail");
        return;
      }
    }

    this.state = {
      username: this.props.location.state.username,
      password: "",
      errMsgs: [],
      loading: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.reroute = this.reroute.bind(this);
  }

  handleChange(event) {
    this.setState({
      ...this.state,
      ...{
        password: event.target.value,
      },
    });
  }

  reroute() {
    this.setState({ loading: true });
    const validData = validLoginDonor(this.state, this.props.language);

    if (!validData.isValid) {
      this.setState({
        errMsgs: validData.msgs,
        loading: false,
      });
      return false;
    }

    this.props
      .login({
        username: this.state.username,
        password: this.state.password,
      })
      .then((res) => {
        let err = [];
        switch (res.status) {
          case 422:
            err.push(res.body.message);
            break;
          case 204:
            this.props.history.push({
              pathname: "/SelectMission",
            });
            break;
          default:
            err.push(res.body.message);
            break;
        }
        this.setState({
          errMsgs: err,
          loading: false,
        });
      });
  }

  render() {
    // The constructor already redirects away when location.state is missing
    // (direct visit / refresh wipes it). Bail out of this transitional render
    // so we don't dereference undefined state before that navigation lands.
    if (!this.props.location.state || !this.props.location.state.color) {
      return null;
    }

    const languageObj = this.props.languageObj;
    const logoStyle = this.props.location.state.logoStyle;
    const resolved = resolveThemeColors(
      this.props.location.state.color.headerColor,
      this.props.location.state.color.buttonColor
    );
    const originalHeaderStyle = {
      background: "#" + this.props.location.state.color.headerColor,
    };
    const backgroundOverrideStyle = {
      background: "#" + resolved.headerColor,
    };
    const textOverrideStyle = {
      color: "#" + resolved.buttonColor,
    };

    const organizationName = this.props.location.state.organizationName;

    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        this.reroute();
      }
    };

    return (
      <div className="LoginPassword-view" data-testid="loginpassword-view">
        <Helmet>
          <title>{organizationName}</title>
        </Helmet>
        <div className="LoginPassword-prompt">
          <Link
            to={{
              pathname: "/LoginEmail",
              state: {
                logoStyle: logoStyle,
                organizationName: organizationName,
                color: {
                  headerColor: this.props.location.state.color.headerColor,
                  buttonColor:
                    this.props.location.state.color.headerColor.buttonColor,
                },
              },
            }}
          >
            <div className="LoginPassword-backContainer">
              <div className="LoginPassword-back">
                <div className="LoginPassword-backBtn"></div>
                <div className="LoginPassword-backText">
                  {languageObj.backTxt}
                </div>
              </div>
            </div>
          </Link>

          <div
            className="LoginPassword-logoContainer"
            style={originalHeaderStyle}
          >
            {logoStyle && (
              <div className="LoginPassword-logo" style={logoStyle}></div>
            )}
          </div>

          <div className="LoginPassword-text">{languageObj.text}</div>

          <div className="LoginPassword-inputFieldContainer">
            <div className="LoginPassword-inputContainerLeft">
              <input
                onChange={this.handleChange}
                type="password"
                className="LoginPassword-inputField"
                placeholder={languageObj.placeholder}
                onKeyDown={handleKeyDown}
                data-testid="loginpassword-password-input"
              />
            </div>
            <div className="LoginPassword-inputContainerRight">
              <div
                onClick={this.reroute}
                className="LoginPassword-nextBtn"
                style={backgroundOverrideStyle}
                data-testid="loginpassword-submit-btn"
              >
                {this.state.loading ? (
                  <div
                    className="LoginPassword-nextText"
                    style={textOverrideStyle}
                  >
                    Loading...
                  </div>
                ) : (
                  <div
                    className="LoginPassword-nextText"
                    style={textOverrideStyle}
                  >
                    {languageObj.btn}
                  </div>
                )}
              </div>
            </div>
          </div>

          {this.state.errMsgs.map((err) => (
            <div key={err} className="LoginPassword-errorContainer">
              <div className="LoginPassword-errorIndicator"></div>
              <div className="LoginPassword-errorMessage">{err}</div>
            </div>
          ))}

          <Link
            to={{
              pathname: "/ForgotPassword",
              state: this.props.location.state,
              logoStyle: logoStyle,
              organizationName: organizationName,
            }}
          >
            <div className="LoginPassword-forgotPassword">
              {languageObj.forgotPassword}
            </div>
          </Link>

          <div className="LoginPassword-chin"></div>
        </div>
      </div>
    );
  }
}

LoginPassword.propTypes = {
  login: PropTypes.func,
  languageObj: PropTypes.object,
  language: PropTypes.string,
};

export default LoginPassword;
